import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import CoverInfo from "./CoverInfo";
import PolicyHolder from "./PolicyHolder";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getCover,
  resetClaimStatus,
  resetPolicyHolder,
} from "../../../redux/slice/claim/claimSlice";
import { getAllCovers } from "../../../redux/slice/cover/coverSlice";
import { useDispatch } from "react-redux";

const Claims = () => {
  const { policyHolder, isLoading } = useSelector((state) => state.claim);
  const [tab, setTab] = useState("policy holder");
  const [policyInfo, setPolicyInfo] = useState();
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const policyHolderRef = useRef();

  const breadcrumb = {
    from: {
      title: "Claims",
      link: "/admin/claims/all-claims",
    },
    current: {
      title: "Claims Process",
      link: null,
    },
  };

  useEffect(() => {
    if (policyHolder) {
      dispatch(getAllCovers());
      dispatch(getCover({id: policyHolder?.app_details?.policy_id}));
    }
  }, [policyHolder]);

  useEffect(() => {
    dispatch(resetClaimStatus());
    dispatch(resetPolicyHolder());
  }, []);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "claim module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "initiate claim"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Claims Process' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <div className='card-body'>
              <div className='border border-1 rounded-1 p-2'>
                <div className='row my-1'>
                  <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                    <li className='nav-item cursor-p'>
                      <span
                        ref={policyHolderRef}
                        onClick={() => setTab("policy holder")}
                        aria-expanded='false'
                        className={`nav-link rounded-0 p-tab-y-1 ${
                          tab === "policy holder" && "active"
                        } border`}
                      >
                        <i className='mdi mdi-home-variant d-md-none d-block'></i>
                        <span className='d-none d-md-block'>Policy Holder</span>
                      </span>
                    </li>
                    <li className='nav-item cursor-p'>
                      <span
                        // data-bs-toggle='tab'
                        onClick={() => {
                          policyHolder && setTab("cover_info");
                        }}
                        aria-expanded='true'
                        aria-disabled={true}
                        className={`nav-link rounded-0 ${
                          tab === "cover_info" && "active"
                        } border`}
                      >
                        <i className='mdi mdi-account-circle d-md-none d-block'></i>
                        <span className='d-none d-md-block'>
                          Cover Information
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
                <div className='row'>
                  {tab === "policy holder" && (
                    <div className='policy holder active' id='policy holder'>
                      <PolicyHolder
                        setTab={setTab}
                        setPolicyInfo={setPolicyInfo}
                        policyInfo={policyInfo}
                      />
                    </div>
                  )}
                  {tab === "cover_info" && policyHolder && (
                    <div className='active' id='cover_info'>
                      <CoverInfo policyHolderRef={policyHolderRef} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Claims;
